import React from 'react';
import { useAuth } from '../context/AuthContext';
import CompanyDetail from './CompanyDetail';
import { AlertCircle } from 'lucide-react';

/**
 * MyCompany - Wrapper component for company users
 * 
 * This component simply renders CompanyDetail with the user's company ID.
 * This ensures company users see the exact same view as administrators,
 * with role-based adjustments handled within CompanyDetail itself.
 */
const MyCompany = () => {
  const { user } = useAuth();
  
  // If no company assigned, show error
  if (!user?.company_id) {
    return (
      <div className="text-center py-12" data-testid="my-company-error">
        <AlertCircle className="w-12 h-12 mx-auto text-amber-500 mb-4" />
        <h3 className="text-lg font-medium text-slate-900">No company assigned</h3>
        <p className="text-slate-500 mt-2 max-w-md mx-auto">
          No company is assigned to your account. Please contact an administrator.
        </p>
      </div>
    );
  }

  // Render the same CompanyDetail component used by admins
  return <CompanyDetail companyId={user.company_id} />;
};

export default MyCompany;
